var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskListEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6301 14.8814L15.0001 22.5114L11.2501 23.2614L12.0001 19.5114L19.6311 11.8814C20.0277 11.4848 20.5657 11.262 21.1266 11.262C21.6875 11.262 22.2255 11.4848 22.6221 11.8814L22.6311 11.8904C23.0276 12.2872 23.2502 12.8252 23.25 13.3861C23.2498 13.947 23.0268 14.4849 22.6301 14.8814V14.8814Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24908 10.5113H14.2491",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24908 14.2613H11.2491",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24908 18.0113H8.24908",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24908 23.2613H2.24908C1.85126 23.2613 1.46973 23.1033 1.18842 22.822C0.90712 22.5407 0.749084 22.1591 0.749084 21.7613V6.01131C0.749084 5.61348 0.90712 5.23195 1.18842 4.95065C1.46973 4.66934 1.85126 4.51131 2.24908 4.51131H6.00008C6.00008 3.51675 6.39517 2.56292 7.09843 1.85966C7.8017 1.15639 8.75552 0.761307 9.75008 0.761307C10.7446 0.761307 11.6985 1.15639 12.4017 1.85966C13.105 2.56292 13.5001 3.51675 13.5001 4.51131H17.2501C17.6479 4.51131 18.0294 4.66934 18.3107 4.95065C18.592 5.23195 18.7501 5.61348 18.7501 6.01131V8.26131",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74909 3.76131C9.82325 3.76131 9.89576 3.7833 9.95743 3.82451C10.0191 3.86571 10.0672 3.92428 10.0955 3.9928C10.1239 4.06132 10.1314 4.13672 10.1169 4.20947C10.1024 4.28221 10.0667 4.34903 10.0143 4.40147C9.96181 4.45392 9.89499 4.48963 9.82224 4.5041C9.7495 4.51857 9.6741 4.51115 9.60558 4.48276C9.53706 4.45438 9.47849 4.40632 9.43728 4.34465C9.39608 4.28298 9.37409 4.21048 9.37409 4.13631C9.37395 4.08703 9.38356 4.0382 9.40236 3.99265C9.42116 3.94709 9.44878 3.9057 9.48363 3.87085C9.51847 3.836 9.55987 3.80838 9.60542 3.78958C9.65098 3.77079 9.6998 3.76118 9.74909 3.76131",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskListEdit);
export default __webpack_public_path__ + "static/media/TaskListEdit.2b5d22cd3366c73b427ef6ec57f2f4c6.svg";
export { ForwardRef as ReactComponent };